

import React from "react"
import { Box, Button, TextField, Typography, Skeleton } from "@mui/material"
import { ReactComponent as SearchIcon } from "../../../../assets/images/KnowledgeBase/preview-search-icon.svg"

export function PreviewHero({ brandColor, accentColor, viewMode = "web", fontFamily, loading }) {
    const isMobile = viewMode === "mobile";
    const isTab = viewMode === "tab";

    return (
        <Box
            sx={{
                backgroundColor: loading ? "#E5E9EC" : (brandColor || "#148DFD"),
                borderRadius: "8px 8px 0 0",
                p: isMobile ? 2.5 : 4,
                textAlign: "center",
                color: "#FFF",
                mt: -2,
                fontFamily: fontFamily || "Inter",
            }}
        >
            {loading ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1, }} />
                    <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3, }} />
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Skeleton variant="rounded" width={170} height={24} />
                        <Skeleton variant="rounded" width={70} height={24} />
                    </Box>
                </Box>
            ) : (
                <>
                    <Typography
                        sx={{
                            fontSize: isMobile ? '19.264px' : isTab ? '28px' : '33.201px',
                            fontWeight: 700,
                            mb: '7px',
                            lineHeight: 1.2,
                            fontFamily: `${fontFamily || "Inter"} !important`,
                        }}
                    >
                        How can we help?
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: isMobile ? '8.562px' : ' 9.486px',
                            color: "rgba(255, 255, 255, 0.9)",
                            mb: isMobile ? '18.63px' : '16px',
                            fontFamily: `${fontFamily || "Inter"} !important`,
                        }}
                    >
                        Get answers and explore new ways to use TrustChat
                    </Typography>

                    <Box sx={{ display: "flex", gap: isMobile ? '4.47px' : 1, justifyContent: "center", alignItems: "center" }}>
                        <TextField
                            placeholder="Search"
                            size="small"
                            InputProps={{
                                endAdornment: <SearchIcon />
                            }}
                            sx={{
                                width: isMobile ? '186.207px' : 170,
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                    color: "#FFF",
                                    fontSize: isMobile ? '7px' : '8px',
                                    height: isMobile ? '25.982px !important' : '23.715px !important',
                                    borderRadius: '3.162px;',
                                    paddingRight: '7px !important',
                                    fontFamily: `${fontFamily || "Inter"} !important`,
                                    "& fieldset": {
                                        borderColor: "transparent",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "rgba(255, 255, 255, 0.3)",
                                    },
                                    "&:focus-within fieldset": {
                                        borderColor: "transparent !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "transparent !important",
                                    },
                                },
                                "& .MuiOutlinedInput-input::placeholder": {
                                    color: "rgba(255, 255, 255, 0.6)",
                                    opacity: 1,
                                    fontFamily: `${fontFamily || "Inter"} !important`,
                                },

                            }}
                        />
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#FFF",
                                color: accentColor || brandColor,
                                fontSize: isMobile ? '7px' : '8px',
                                textTransform: "none",
                                fontWeight: 600,
                                py: 1,
                                fontFamily: `${fontFamily || "Inter"} !important`,
                                height: isMobile ? '25.982px !important' : '23.715px !important',
                                width: isMobile ? '77.947px' : '71.146px',
                                "&:hover": {
                                    backgroundColor: "#FFF",
                                },
                            }}
                        >
                            Search
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    )
}
